import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { GroupService } from '@core/services/group.service';

export const adminOnlyGuard: CanActivateFn = () => {
  const gs = inject(GroupService);
  const router = inject(Router);

  if (gs.isAdminUser()) {
    return true;
  } else {
    router.navigate(['/login']);
    return false;
  }
};
